import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

import { vehiclesListSearchSchema } from '&/features/vehicles/lib/vehicles-list-search';

/**
 * The read-only vehicle-profile layout (SWOOP-154 / 158 / 159). Un-nested from the Add/Edit wizard
 * layout (`vehicles_.$vehicleId.tsx`) via the trailing-underscore segment `$vehicleId_`, so it renders
 * standalone (no stepper) and is gated on `vehicles:list` (read) rather than the wizard's
 * `vehicles:manage`. Renders the shared profile header + sibling-tab bar around an `<Outlet />`; the tab
 * bodies are its nested routes (`/overview` index, `/overview/insurance`, `/overview/acquisition`).
 * Nested under `overview` because the flat `/vehicles/$vehicleId/{insurance,acquisition}` paths already
 * belong to the wizard steps.
 */
export const Route = createFileRoute('/_authenticated/vehicles_/$vehicleId_/overview')({
  beforeLoad: ({ context }): void => {
    if (context.permissions.isReady && !context.permissions.hasPermission('vehicles:list')) {
      throw redirect({ to: '/vehicles' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/vehicles/pages/vehicle-profile-layout-page')),
  staticData: { dynamic: true },
  // Shares the vehicles-list search schema (SWOOP-230): the profile carries the list's tab / filters /
  // search / page / sort through unchanged (its links use `search: (prev) => prev`) so the header Back
  // link and the sibling profile-tab links can return to `/vehicles` with the list state intact.
  validateSearch: (search) => vehiclesListSearchSchema.parse(search),
});
